import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-new-inform',
  templateUrl: './new-inform.component.html',
  styleUrls: ['./new-inform.component.css']
})
export class NewInformComponent {
  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.userlv = userdata.userlevel
    console.log('userdata: ', userdata);
    if (userdata.userlevel == '6' || userdata.userlevel == '7' || userdata.userlevel == '9' || userdata.userlevel == '10') {
      this.editer = true
    } else this.editer = false;

  }

  ngOnInit(): void {
  }
  userdata

  editer = false
  year_L = [ //รายการปี
    ["6768", "67", "2425", "24", "ปี 2567/2568"],
  ]
  year_S = [];

  select_year() {
    this.Loaddatacontact();
  }

  edit_st = 0;
  zone = ''; supcode = ''; userlv = '';
  year = ''; S_texe = '';
  Selectfarmer = [];
  Loaddatacontact() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=trim(fmcode)[fmcode],trim(fmcode_b1)[fmcode_b1],trim(fmname)[fmname],SUPZONE,SUPCODE,groupCode,[inform_ERN_" + this.year_S[1] + "][inform_ERN],[inform_ERO_" + this.year_S[1] + "][inform_ERO],[inform_ST_" + this.year_S[1] + "][inform_ST]&f=[CPS6263].[dbo].[t_farmer]&w=SUPCODE='" + this.supcode + "'order by [fmname]";
    axios.get(url).then(res => {
      let data = res.data;
      data = data.map(item => {
        return { ...item, modify: false };
      });
      this.Selectfarmer = data;
      console.log('t_farmer:', data)
    }).catch(error => {
      console.log(error);
    })
  }


  saveData() {
    let value = this.Selectfarmer.filter((el) => el.modify == true);
    let x = 0, y = 0;
    if (value.length > 0) {
      let supcode = value.map(function (elem) { return elem.Supcode });
      if (confirm('ต้องการบันทึกข้อมูล ' + supcode + ' | จำนวน ' + value.length + ' คน หรือไม่?')) {
        for (let i = 0; i < value.length; i++) {
          let url: string, ar0 = value[i]
          url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbo].[t_farmer]&s=
          [inform_ERN_${this.year_S[1]}]=` + ar0.inform_ERN + ` , [inform_ERO_${this.year_S[1]}]=` + ar0.inform_ERO + ` , [inform_ST_${this.year_S[1]}]=` + ar0.inform_ST + `  &w= fmcode_b1='` + ar0.fmcode_b1 + `'`;
          axios.post(url).then(res => {
            let data = res.data;
            if (data.rowsAffected[0] == 1) y++
            else x++
          }).catch(err => { console.log(err) })
          //console.log('url', i, ';', url)
        }
        //alert("สำเร็จ:" + y + " ไม่สำเร็จ:" + x);
        console.log('สำเร็จ', y, 'ไม่สำเร็จ', x)
        this.edit_st = 0
        setTimeout(() => {
          this.Loaddatacontact();
        }, 200);
      }
    }
    else alert('ยังไม่มีการแก้ไข')
  }

}



